export default __webpack_public_path__ + "static/dj-8fc9aaecb2871e830979eaa6437ded7f.svg";